if (!customElements.get('notification-upsell')) {
  class NotificationUpsell extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');

      this.selectItem = this.querySelector('[data-select]');

      this.selectItem?.addEventListener('change', this.handleVariantChange.bind(this));
      this.productHandle = this.dataset.handle;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    /**
     * handleVariantChange
     * @param {Object} event
     */
    async handleVariantChange(event) {
      const response = await fetch(
        `/products/${this.productHandle}?variant=${event.target.value}&section_id=cart-notification-upsell`
      );
      const html = await response.text();
      this.parentElement.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.shopify-section').innerHTML;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      // formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          // Close the notification by default
          this.cartNotification.close();

          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          this.cartDrawer.renderContents(parsedState);

          // Check if the rebuy smartCart is enabled. If so, we don't need to do anything. Stop and Rebuy will handle the drawer.
          if (window.Rebuy?.SmartCart?.status === 'ready') return;
          // Set timeout to force animation. Because content is just updated with renderContents
          setTimeout(() => {
            this.cartDrawer.open();
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // Close the notification by default
          this.cartNotification.close();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.NotificationUpsell = NotificationUpsell;
  customElements.define('notification-upsell', NotificationUpsell);
}
